import type {
  GetListParams,
  GetListResult,
  GetManyParams,
  GetManyResult,
} from "ra-core";
import { toRaAssignee, type AssigneeRaRecord } from "./Mappers";
import type { PageQuery } from "@/domain/port/PageQuery";
import type { AssigneesService } from "@/domain/port/AssigneesService";

export function makeAssigneesAdapter(assignees: AssigneesService) {
  return {
    async getList(
      _resource: string,
      params: GetListParams,
    ): Promise<GetListResult<AssigneeRaRecord>> {
      const { page, perPage } = params.pagination ?? { page: 1, perPage: 25 };
      const q: PageQuery = {
        page,
        pageSize: perPage,
      };
      const res = await assignees.list(q);
      return { data: res.items.map(toRaAssignee), total: res.total };
    },

    async getMany(
      _resource: string,
      params: GetManyParams,
    ): Promise<GetManyResult<AssigneeRaRecord>> {
      const ids = params.ids.map(String);
      const items = await assignees.getManyByIds(ids);
      return { data: items.map(toRaAssignee) };
    },
  };
}
